import type { AccountProtectionAccordions } from '@/types/UserLimits';

const accordionToOpen = ref<AccountProtectionAccordions | null>(null);

export const useAccountProtection = () => {
  const { t } = useTexts();
  const { getDateTime } = useDateTimeHelper();

  const choiceOptions = [
    { value: 0, label: t('general.unlimited') },
    { value: 1, label: t('general.custom') },
  ];

  const periodsOptions = [
    { value: '0', label: t('account.account_protection.select_period') },
    { value: '1', label: t('general.daily') },
    { value: '2', label: t('general.weekly') },
    { value: '3', label: t('general.monthly') },
    { value: '4', label: t('general.yearly') },
  ];

  function getPeriodLabel(periodId?: number | null): string {
    if (periodId == null) return '';

    const period = periodsOptions.find(
      (option) => option.value === periodId.toString(),
    );

    return period?.label ?? '';
  }

  function getTimePlusOneDay(date: string) {
    return new Date(new Date(date).getTime() + 24 * 60 * 60 * 1000);
  }

  function isBlockedToChange(date?: string) {
    if (!date) {
      return false;
    }

    const nextChangeDate = getTimePlusOneDay(date);

    if (
      isNaN(nextChangeDate.getTime()) ||
      nextChangeDate.toISOString() < new Date().toISOString()
    ) {
      return false;
    }

    return true;
  }

  function getTimeToNextChange(date: string) {
    if (!date) {
      return;
    }

    return getDateTime(getTimePlusOneDay(date).toISOString());
  }

  function forceOpenAccordion(accordionId: AccountProtectionAccordions) {
    console.log('forceOpenAccordion', accordionId);
    accordionToOpen.value = accordionId;

    setTimeout(() => {
      accordionToOpen.value = null;
    }, 1000);
  }

  return {
    choiceOptions,
    periodsOptions,
    isBlockedToChange,
    getTimeToNextChange,
    getPeriodLabel,
    accordionToOpen,
    forceOpenAccordion,
  };
};
